module.exports = __webpack_public_path__ + "img/chip-border.91a2d392.png";